import { useEffect } from 'react';
import { useGetResourcesQuery } from '@/store/quickLinksResourcesApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAuthIsLoaded } from '@/hooks/useAuthIsLoaded';
import { StandardWidgetProps } from '@/models/WidgetModels';
import { useLocalization } from '@/hooks/useLocalization';
import { ResourcesCarousel } from '../resourcesCarousel';

export default function DashboardResources({
  onDataLoaded,
  isWidget,
  title,
  container = 'widget',
}: StandardWidgetProps) {
  const { t } = useLocalization();

  const authLoaded = useAuthIsLoaded();
  const {
    data: resourcesData,
    isLoading,
    error,
  } = useGetResourcesQuery(authLoaded ? undefined : skipToken);

  useEffect(() => {
    if (resourcesData) {
      onDataLoaded?.();
    }
  }, [resourcesData, onDataLoaded]);

  return (
    <ResourcesCarousel
      records={resourcesData?.Records}
      isLoading={isLoading}
      hasError={!!error}
      title={title ?? t('resources')}
      errorText={t('resources.errorLoading')}
      emptyText={t('resources.noResourcesAvailable')}
      isWidget={isWidget}
      container={container}
    />
  );
}
